import { Fragment } from 'react';
import { AttributeCode } from 'services/model/model.service';
import { TranslatedAttributeLabel } from 'pages/trading/TranslatedAttributeLabel';
import { ExtendedAttributeCode } from 'pages/trading/model';
import { FilterValue } from 'components/breadcrumb/breadcrumbModel';

const KEY_ATTRIBUTES: AttributeCode[] = ['prdNumber', 'prdCategory', 'chnMarketplace', 'chnCountry'];
const ORDERED_ATTRIBUTES: AttributeCode[] = ['prdBrand', 'chnMarketplace', 'chnCountry', 'chnFulfillmentMethod'];

interface DrillDownTitleProps {
  filterAttributes: Record<ExtendedAttributeCode, FilterValue[]>;
}

export function DrillDownTitle({ filterAttributes }: DrillDownTitleProps) {
  const attributeCodes = Object.getOwnPropertyNames(filterAttributes) as AttributeCode[];

  const keyAttribute = KEY_ATTRIBUTES.find(att => attributeCodes.includes(att));

  const orderedAdditionalAttributes = ORDERED_ATTRIBUTES.filter(att => att !== keyAttribute).filter(att =>
    attributeCodes.includes(att)
  );

  return (
    <>
      {keyAttribute && (
        <>
          <TranslatedAttributeLabel
            attributeCode={keyAttribute}
            attributeValue={filterAttributes[keyAttribute]?.join(', ') ?? ''}
          />{' '}
          {orderedAdditionalAttributes.length > 0 && <>in </>}
          {orderedAdditionalAttributes.map((att, idx) => (
            <Fragment key={att}>
              <TranslatedAttributeLabel
                attributeCode={att}
                attributeValue={(filterAttributes[att][0] ?? '') as string}
              />
              {idx < orderedAdditionalAttributes.length - 1 && ', '}
            </Fragment>
          ))}
        </>
      )}
    </>
  );
}
